import cx from 'classnames'
import React from 'react'
import styles from './styles.module.scss'

export function SurveyLandingPageLayout({
  backgroundImgSrc,
  children
}: {
  backgroundImgSrc?: string
  children: React.ReactNode
}) {
  const processBgImageProps = (bgImage?: string): { className: string; style: React.CSSProperties } => ({
    className: cx(styles['bg-image'], bgImage && 'u-bg-linear-gradient'),
    style: bgImage ? ({ '--bg-url': `url(${bgImage})` } as React.CSSProperties) : {}
  })
  return (
    <div className={styles.container}>
      <div style={{ position: 'relative' }}>
        <div {...processBgImageProps(backgroundImgSrc)} data-testid="survey-bg-container" />
        <div className={styles['outer-content-container']}>
          <div className={styles['inner-content']}>{children}</div>
        </div>
      </div>
    </div>
  )
}
